import { IAnnouncement } from '../../@types/Announcement';
import adminAPIClient from './apiClient';

export default function getTenantAnnouncements(tenantId: string) {
    return adminAPIClient
        .get(`tenants/${tenantId}/announcements`)
        .then((result) => result.data as IAnnouncement[]);
}
